import type { AugmentedMember, MessagingUser, ProcessedGroupChannel } from "../types";

export function processSendBirdChannel(
  user: MessagingUser,
  channel: SendBird.GroupChannel,
): ProcessedGroupChannel {
  const result = channel as ProcessedGroupChannel;

  result.otherMembers = channel.members.filter((member) => member.userId !== user.user_id);

  result.otherMembersMap = result.otherMembers.reduce<Record<string, AugmentedMember>>(
    (map, member) => {
      const augmented = member as AugmentedMember;

      augmented.lastMessage = channel.lastMessage;
      augmented.unreadMessageCount = channel.unreadMessageCount;
      map[member.userId] = augmented;

      return map;
    },
    {},
  );

  return result;
}
